module.exports = __webpack_public_path__ + "img/bannerLabel2Orange.a4de714c.png";